import React from "react";
import bgImg from "../Assets/pexels-canvastudio-3194521.jpg";

const WhyUs = () => {
  const data = [
    {
      title: "Modern Web Development",
      desc: "We build highly responsive and modern websites using latest technologies for best performance.",
      img: "https://cdn-icons-png.flaticon.com/512/1055/1055687.png",
    },
    {
      title: "Fast Delivery",
      desc: "We deliver projects quickly without compromising on quality and performance.",
      img: "https://cdn-icons-png.flaticon.com/512/889/889221.png",
    },
    {
      title: "Mobile Friendly Design",
      desc: "Every website we build works perfectly on all screen sizes and devices.",
      img: "https://cdn-icons-png.flaticon.com/512/888/888857.png",
    },
    {
      title: "SEO Optimization",
      desc: "We optimize websites to rank higher on Google and increase organic traffic.",
      img: "https://cdn-icons-png.flaticon.com/512/2620/2620985.png",
    },
    {
      title: "Secure Development",
      desc: "We follow best security practices to keep your data and website safe.",
      img: "https://cdn-icons-png.flaticon.com/512/3064/3064197.png",
    },
    {
      title: "24/7 Support",
      desc: "We provide continuous support even after project delivery.",
      img: "https://cdn-icons-png.flaticon.com/512/1946/1946429.png",
    },
  ];

  return (
    <section className="relative py-28 overflow-hidden">

      {/* BACKGROUND IMAGE */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${bgImg})` }}
      />

      {/* DARK OVERLAY */}
      <div className="absolute inset-0 bg-black/70"></div>

      {/* CONTENT */}
      <div className="relative z-10">

        {/* HEADER */}
        <div className="text-center mb-16 text-white">
          <p className="text-red-400 font-semibold uppercase tracking-widest text-sm">
            Why Choose Us
          </p>

          <h2 className="mt-3 text-4xl md:text-5xl font-bold">
            We Deliver Digital Excellence
          </h2>

          <div className="w-24 h-1 bg-red-500 mx-auto mt-4 rounded-full"></div>
        </div>

        {/* CARDS */}
        <div className="max-w-7xl mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-10">

          {data.map((item, i) => (
            <div
              key={i}
              className="group bg-white/90 backdrop-blur-md p-10 rounded-2xl shadow-lg hover:shadow-2xl transition hover:-translate-y-2 border border-white/30"
            >

              {/* IMAGE */}
              <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-contain group-hover:scale-110 transition"
                />
              </div>

              {/* TITLE */}
              <h3 className="text-2xl font-semibold text-center text-gray-800 group-hover:text-red-600">
                {item.title}
              </h3>

              {/* DESCRIPTION */}
              <p className="mt-4 text-gray-500 text-center leading-relaxed">
                {item.desc}
              </p>

            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default WhyUs;